import { GetBankAccountDataResponse } from '@/modules/bank/type'
import { ColumnDef } from '@tanstack/react-table'
// import { IsActiveBank } from './CellAction/components/IsActiveBank'
import DeleteBankModal from './CellAction/components/DeleteBank'
import EditOrder from './CellAction/components/EditOrder'
import { Button } from '@/common/ui/button'
import { Pencil } from 'lucide-react'
import { Link } from 'react-router-dom'

export const columns: ColumnDef<GetBankAccountDataResponse>[] = [
	{
		header: 'ข้อมูลบัญชี',
		accessorKey: 'accountInfo',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p className="text-xs text-muted-foreground">
					ลำดับ: {row.original.order}
				</p>
				<p>เลขที่บัญชี: {row.original.accountNumber}</p>
				<p>ชื่อบัญชี: {row.original.accountName}</p>
				<p className="text-xs text-muted-foreground">
					ธนาคาร: {row.original.bankProvider}
				</p>
			</div>
		),
	},
	{
		header: 'เวลา',
		accessorKey: 'dateInfo',
		cell: ({ row }) => (
			<div className="space-y-1 text-sm">
				<p>สร้าง: {new Date(row.original.createdAt).toLocaleString()}</p>
				<p className="text-xs text-muted-foreground">
					แก้ไข: {new Date(row.original.updatedAt).toLocaleString()}
				</p>
			</div>
		),
	},
	{
		header: 'จัดการ',
		accessorKey: 'actions',
		cell: ({ row }) => (
			<div className="flex flex-wrap items-center gap-1">
				<EditOrder row={row.original} />
				<Link to={`/operator/bank-account/${row.original.id}`}>
					<Button variant="ghost" size="icon">
						<Pencil className="h-4 w-4" />
					</Button>
				</Link>
				<DeleteBankModal id={row.original.id} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['editOrder', 'id', 'delete', 'isActive']
